import { render, staticRenderFns } from "./TaxCalendar.vue?vue&type=template&id=2e184f2d&scoped=true&"
import script from "./TaxCalendar.vue?vue&type=script&lang=ts&"
export * from "./TaxCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./TaxCalendar.vue?vue&type=style&index=0&id=2e184f2d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e184f2d",
  null
  
)

export default component.exports